export default __webpack_public_path__ + "static/media/inopticlasoff.487e59ba.svg";